import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  DropdownOption,
  GcIconComponent,
  IpoLanguageService,
} from '@ip-only/front-end-library';
import {
  fadeAnimation,
  growAnimation,
  listFadeAnimation,
} from '../../animations/enter-leave-animations';

interface DropdownOptionWithIcon<T> extends DropdownOption<T> {
  icon: string;
}
type Language = 'en' | 'sv' | 'fi';

const baseFlagUrl = 'https://assets.globalconnect.net/images/icons';
const enFlagUrl = `${baseFlagUrl}/flag-eng.svg`;
const svFlagUrl = `${baseFlagUrl}/flag-swe.svg`;
const fiFlagUrl = `${baseFlagUrl}/flag-fi.svg`;

@Component({
  selector: 'app-translation-picker',
  imports: [CommonModule, GcIconComponent],
  templateUrl: './translation-picker.component.html',
  styleUrls: ['./translation-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeAnimation, growAnimation, listFadeAnimation({ delay: 200 })],
})
export class TranslationPickerComponent {
  expanded = false;
  language$ = this.languageService.getLanguage$();
  languages: Language[] = ['en', 'sv', 'fi'];
  languageMap: Record<string, DropdownOptionWithIcon<Language>> = {
    sv: {
      value: 'sv',
      label: 'Svenska',
      icon: svFlagUrl,
    },
    en: {
      value: 'en',
      label: 'English',
      icon: enFlagUrl,
    },
    fi: {
      value: 'fi',
      label: 'Suomalainen',
      icon: fiFlagUrl,
    },
  };

  @Output() languageClicked = new EventEmitter();

  constructor(private languageService: IpoLanguageService) {}

  closeDropdown() {
    this.expanded = false;
  }

  toggleDropdown() {
    this.expanded = !this.expanded;
  }

  selectOption(language: Language) {
    this.languageService.setLanguage(language);
    this.closeDropdown();
    this.languageClicked.emit();
  }

  onOptionClick(event: Event, language: Language) {
    event.preventDefault();
    this.selectOption(language);
  }

  closedByKey() {
    this.closeDropdown();
  }
}
